export default "__VITE_PUBLIC_ASSET__2515f47f__"